// src/config/app-route.jsx
import React from 'react';
import App from './../app.jsx';
import { Navigate } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import RootRedirect from '../components/RootRedirect.jsx';

// --- pages (imports must be before any code)
import Dashboard from './../pages/custom-dashboard/customDashboard.js';
import Analytics from './../pages/analytics/analytics.js';
import EmailInbox from './../pages/email/inbox.js';
import EmailCompose from './../pages/email/compose.js';
import EmailDetail from './../pages/email/detail.js';
import Widgets from './../pages/widgets/widgets.js';
import AiChat from './../pages/ai/chat.js';
import AiImageGenerator from './../pages/ai/image-generator.js';
import PosCustomerOrder from './../pages/pos/customer-order.js';
import PosKitchenOrder from './../pages/pos/kitchen-order.js';
import PosCounterCheckout from './../pages/pos/counter-checkout.js';
import PosTableBooking from './../pages/pos/table-booking.js';
import PosMenuStock from './../pages/pos/menu-stock.js';
import UiBootstrap from './../pages/ui/bootstrap.js';
import UiButtons from './../pages/ui/buttons.js';
import UiCard from './../pages/ui/card.js';
import UiIcons from './../pages/ui/icons.js';
import UiModalNotifications from './../pages/ui/modal-notifications.js';
import UiTypography from './../pages/ui/typography.js';
import UiTabsAccordions from './../pages/ui/tabs-accordions.js';
import FormElements from './../pages/form/elements.js';
import FormPlugins from './../pages/form/plugins.js';
import FormWizards from './../pages/form/wizards.js';
import TableElements from './../pages/table/elements.js';
import TablePlugins from './../pages/table/plugins.js';
import ChartJs from './../pages/charts/js.js';
import ChartApex from './../pages/charts/apex.js';
import Map from './../pages/map/map.js';
import LayoutStarter from './../pages/layout/starter.js';
import LayoutFixedFooter from './../pages/layout/fixed-footer.js';
import LayoutFullHeight from './../pages/layout/full-height.js';
import LayoutFullWidth from './../pages/layout/full-width.js';
import LayoutBoxedLayout from './../pages/layout/boxed-layout.js';
import LayoutCollapsedSidebar from './../pages/layout/collapsed-sidebar.js';
import LayoutTopNav from './../pages/layout/top-nav.js';
import LayoutMixedNav from './../pages/layout/mixed-nav.js';
import LayoutMixedNavBoxedLayout from './../pages/layout/mixed-nav-boxed-layout.js';
import PagesScrumBoard from './../pages/pages/scrum-board.js';
import PagesProducts from './../pages/pages/products.js';
import PagesProductDetails from './../pages/pages/product-details.js';
import PagesOrders from './../pages/pages/orders.js';
import PagesOrderDetails from './../pages/pages/order-details.js';
import ProductSales from '../pages/orders/Product-Sales.js';
import ProductSaleCompare from '../pages/orders/2-Periods-Product-Sales.js'
import OrdersUnitsHeatmapByState from '../pages/orders/OrdersUnitsHeatmapByState.js';
import PagesGallery from './../pages/pages/gallery.js';
import PagesSearchResults from './../pages/pages/search-results.js';
import PagesComingSoon from './../pages/pages/coming-soon.js';
import PagesError from './../pages/pages/error.js';
import PagesLogin from './../pages/pages/newLogin.js';
import PagesRegister from './../pages/pages/register.js';
import PagesMessenger from './../pages/pages/messenger.js';
import PagesDataManagement from './../pages/pages/data-management.js';
import PagesFileManager from './../pages/pages/file-manager.js';
import PagesPricing from './../pages/pages/pricing.js';
import Landing from './../pages/landing/landing.js';
import Profile from './../pages/users/profile.js';
import HardwareProfile from '../pages/hardware/hardwareProfile.js';
import Calendar from './../pages/calendar/calendar.js';
import Settings from './../pages/settings/settings.js';
import Helper from './../pages/helper/helper.js';
import Hardware from './../pages/hardware/hardware.js';
import Users from './../pages/users/users2.js';
import Recipe from '../pages/recipes/recipe.jsx';
import Allrecipe from '../pages/recipes/allrecipe.jsx';
import LatestRecipes from '../pages/recipes/latestrecipes.jsx';
import LatestRecipesPG from '../pages/recipes/latestrecipes_pg.jsx';
import Ingredient from '../pages/ingredients/ingredient.jsx';
import Content from '../pages/content/content.jsx';
import Dashboardadmindata from '../pages/dashboardadmindata/dashboardadmindata.jsx';
import Orders from '../pages/orders/newOrders.js';
import OrderDetails from '../pages/orders/newOrder-details.js';
import OrdersExport from '../pages/orders/OrdersExport.js';
import AdminOrders from '../pages/orders/adminOrders.js';
import AdminOrderDetails from '../pages/orders/adminOrderDetails.js';
import AdminProducts from '../pages/orders/adminProductsPage.js';
import AdminProductDetail from '../pages/orders/adminProductDetailPage.js';
import AdminTaxonomy from '../pages/orders/adminTaxonomyPage.js';
import AdminPages from '../pages/orders/adminPagesPage.js';
import AdminDiscounts from '../pages/orders/adminDiscountsPage.js';
import RevenueBridge from '../pages/orders/revenueBridgePage.js';
import Chat from '../pages/ai/chat.js';
import Jsonformatter from '../pages/jsonformatter/jsonformatter.jsx';
import Gahomemain from '../pages/ganalytics/gahomemain.jsx';
import Gareport from '../pages/ganalytics/gareport.jsx';
import Garealtime from '../pages/ganalytics/garealtime.jsx';

import Webflowanalytics from '../pages/webflowanalytics/webflowrealtime.js';
import Webflowgahomemain from '../pages/webflowanalytics/webflowgahome.js';


import Firebasehome from '../pages/ganalytics/firebase/firebasehome.jsx';
import Firebasereport from '../pages/ganalytics/firebase/firebasereport.jsx';
import Firebaserealtime from '../pages/ganalytics/firebase/firebaserealtime.jsx';
import ProductSalesCompare from '../pages/orders/2-Periods-Product-Sales.js';

// --- small auth/permission guard
const EMPTY = Object.freeze([]);

function Guard({ children, code }) {
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const permsFromState = useSelector((s) => s.auth.permissions, shallowEqual) || EMPTY;
  const userFromState  = useSelector((s) => s.auth.logininfo);

  // localStorage fallback on first load/refresh
  let perms = permsFromState;
  if (!perms.length) {
    try { perms = JSON.parse(localStorage.getItem('permissions') || '[]'); }
    catch { perms = []; }
  }
  const adminFlag = Number(userFromState?.adminFlag ?? localStorage.getItem('adminFlag') ?? 0);

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (!code) return children;           // auth-only route
  if (adminFlag === 1) return children; // admin bypass
  if (!perms.length) return null;       // wait for hydration to avoid flicker

  // DENY -> go to "/" and let RootRedirect pick the first allowed page
  return perms.includes(code) ? children : <Navigate to="/" replace />;
}

const AppRoute = [
  {
    path: '*',
    element: <App />,
    children: [
      { path: '', element: <RootRedirect /> },

      // public
      { path: 'login', element: <PagesLogin /> },
      { path: 'register', element: <PagesRegister /> },

      // auth-only (no specific permission)
      { path: 'settings', element: <Guard><Settings /></Guard> },

      // sections (permission per section)
      { path: 'dashboard', element: <Guard code="dashboard:access"><Dashboard /></Guard> },
      { path: 'hardware', element: <Guard code="hardware:access"><Hardware /></Guard> },
      { path: 'users', element: <Guard code="users:access"><Users /></Guard> },

      { path: 'recipes/*',
        children: [
          { path: 'recipesbyevent', element: <Guard code="recipes:access"><Recipe /></Guard> },
          { path: 'searchrecipes',  element: <Guard code="recipes:access"><Allrecipe /></Guard> },
          { path: 'latestrecipes',  element: <Guard code="recipes:access"><LatestRecipes /></Guard> },
          { path: 'latestrecipespg',  element: <Guard code="recipes:access"><LatestRecipesPG /></Guard> },
        ]
      },

      // note: backend permission is plural (ingredients:access)
      { path: 'ingredients', element: <Guard code="ingredients:access"><Ingredient /></Guard> },

      { path: 'content', element: <Guard code="content:access"><Content /></Guard> },

      { path: 'googleanalytics/*',
        children: [
          { path: 'home',     element: <Guard code="googleanalytics:access"><Gahomemain /></Guard> },
          { path: 'report',   element: <Guard code="googleanalytics:access"><Gareport /></Guard> },
          { path: 'realtime', element: <Guard code="googleanalytics:access"><Garealtime /></Guard> }
        ]
      },

      { path: 'firebaseanalytics/*',
        children: [
          { path: 'home',     element: <Guard code="firebaseanalytics:access"><Firebasehome /></Guard> },
          { path: 'report',   element: <Guard code="firebaseanalytics:access"><Firebasereport /></Guard> },
          { path: 'realtime', element: <Guard code="firebaseanalytics:access"><Firebaserealtime /></Guard> }
        ]
      },

      { path: 'webflowanalytics/*',
        children: [
          { path: 'home',     element: <Guard code="webflowanalytics:access"><Webflowgahomemain /></Guard> },
          // { path: 'report',   element: <Guard code="firebaseanalytics:access"><Firebasereport /></Guard> },
          { path: 'realtime', element: <Guard code="webflowanalytics:access"><Webflowanalytics /></Guard> }
        ]
      },

      {
        path: 'orders/*',
        children: [
          // Orders folder
          { path: 'channel', element: <Guard code="orders:access"><Orders /></Guard> },
          { path: 'export', element: <Guard code="orders:access"><OrdersExport /></Guard> },

          // Admin order management (commerce engine)
          { path: 'manage', element: <Guard code="orders:access"><AdminOrders /></Guard> },
          { path: 'manage/:orderId', element: <Guard code="orders:access"><AdminOrderDetails /></Guard> },
          { path: 'products', element: <Guard code="orders:access"><AdminProducts /></Guard> },
          { path: 'products/:productId', element: <Guard code="orders:access"><AdminProductDetail /></Guard> },
          { path: 'taxonomy', element: <Guard code="orders:access"><AdminTaxonomy /></Guard> },
          { path: 'pages', element: <Guard code="orders:access"><AdminPages /></Guard> },
          { path: 'discounts', element: <Guard code="orders:access"><AdminDiscounts /></Guard> },
          { path: 'revenue-bridge', element: <Guard code="orders:access"><RevenueBridge /></Guard> },

          // Product Sales at E-Commerce level
          { path: 'product-sales', element: <Guard code="orders:access"><ProductSales /></Guard> },
          { path: 'product-sales-compare', element: <Guard code="orders:access"><ProductSalesCompare /></Guard> },
          { path: 'units-heatmap-by-state', element: <Guard code="orders:access"><OrdersUnitsHeatmapByState /></Guard> },

          // Order details
          { path: 'order-details/:channel/:orderId', element: <Guard code="orders:access"><OrderDetails /></Guard> },
        ]
      },



      { path: 'ai', element: <Guard code="ai:access"><Chat /></Guard> },

      { path: 'jsonformatter', element: <Guard><Jsonformatter /></Guard> },

      { path: 'dashboardadmindata', element: <Guard code="dashboardadmindata:access"><Dashboardadmindata /></Guard> },

      // detail pages inherit a parent permission
      { path: 'profile/:userId', element: <Guard code="users:access"><Profile /></Guard> },
      { path: 'hardware-profile/:deviceId', element: <Guard code="hardware:access"><HardwareProfile /></Guard> },
    ]
  }
];

export default AppRoute;
